import type { AlpineComponent } from 'alpinejs';

type Field = {
	id: number;
	value: string;
	quantity: string;
};

type QuickAddProps = {
	fields: Field[];
};

const defaultRow = {
	id: 0,
	value: '',
	quantity: '1'
} as const;

export const quickAdd = (): AlpineComponent<QuickAddProps> => ({
	fields: [{ ...defaultRow }],
	get largestId() {
		return this.fields.length ? Math.max(...this.fields.map(v => v.id)) : 0;
	},
	addRow() {
		this.fields.push({
			...defaultRow,
			id: this.largestId + 1
		});
	},
	deleteRow(field: Field) {
		this.fields = this.fields.filter(v => v.id !== field.id);
	},
	clearAll() {
		this.fields = [];
	},
	submit() {
		console.log(this.fields);
	}
});
